<template>
  <div class="container tab-container p-0">
    <div class="tabs">
      <button
        type="button"
        class="tab"
        v-for="tab in state.tabs"
        :key="tab.id"
        :class="{ active: tab.id === state.currentActive }"
        @click="selectTab(tab.id)"
      >
        <span class="tab__title">{{ tab.title }}</span>
      </button>
    </div>
    <slot />
  </div>
</template>

<script>
import { reactive, provide } from "vue";

export default {
  name: "Tabs",
  setup() {
    const state = reactive({
      currentActive: "",
      tabs: [],
    });

    provide("tabManager", state);

    return { state };
  },
  mounted() {
    this.state.currentActive = 0;
  },

  methods: {
    selectTab(id) {
      this.state.currentActive = id;
    },
  },
};
</script>

<style scoped="scoped">
.tab {
  background: #f3f3f3;
  border: none;
  border-radius: 6px;
  color: #1d1d1d;
  cursor: pointer;
  flex: 1 1 200px;
  padding: 18px 32px;
  transition: background-color 0.25s ease, color 0.25s ease,
    box-shadow 0.25s ease;
}

.tab__title {
  display: block;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.18em;
}

.tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 0;
  padding: 0;
}

.tab:hover {
  background: #e7e7e7;
}

.tab:focus {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}

.active {
  background: #1c1c1c;
  color: #ffffff;
  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.2);
}

.active .tab__title {
  color: #ffffff;
}

@media (max-width: 767.98px) {
  .tab-container {
    padding: 0 !important;
  }

  .tab {
    flex: 1 1 100%;
    text-align: center;
  }
}
</style>
